module.exports = __webpack_public_path__ + "img/bin.c6890422.svg";